import { render, staticRenderFns } from "./ResumeBuilderList.vue?vue&type=template&id=2f4e265e&"
import script from "./ResumeBuilderList.vue?vue&type=script&lang=js&"
export * from "./ResumeBuilderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports